import wp from '@/api/wp'

const all = async ({ commit }, { page, size } = { page: 1, size: 100 }) => {
  commit('setLoading', true)

  let res = await wp.taxo_trabalhos().page(page).perPage(size)

  let list = res.map(value => ({
    text: value.name,
    active: false
  }))

  commit('setList', list)

  commit('setLoading', false)
}

const turnTag = ({ commit }, clickedTag) => {
  commit('turnTag', clickedTag)
}

const turnOffAllTags = ({ commit }) => {
  commit('turnOffAllTags')
}

export default {
  all,
  turnTag,
  turnOffAllTags,
}
